import { useContext } from '@frontend/react';
import { CreateTaskContext } from '@frontend/web/context/CreateTaskContext/createTaskContext';

export const useCreateTaskContext = () => useContext(CreateTaskContext);
